// @flow
import * as React from 'react'
import { colors } from '../colors'

export type PropsType = {
  size?: number,
  color?: string
}

const StoriesIcon = (props: PropsType): React.Node => {
  return (
    <svg
      height={props.size || 30}
      width={props.size || 30}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 14.2501V25.3947C30 26.661 29.5187 27.7509 28.6139 28.5447C27.1989 29.789 25.062 30 23.7914 30C23.2588 30 22.877 29.9622 22.7615 29.9496C21.9497 29.8617 21.3369 29.1873 21.3369 28.3841V18.7423C21.3369 17.8726 22.0524 17.1673 22.9412 17.1673H26.7914V14.2501C26.7914 14.1399 26.6535 3.14997 15 3.14997C3.34332 3.14997 3.20856 14.1399 3.20856 14.2501V17.1673H7.05882C7.94439 17.1673 8.6631 17.8726 8.6631 18.7423V28.3841C8.6631 29.1873 8.04706 29.8617 7.23529 29.9496C7.11979 29.9622 6.73797 30 6.20535 30C4.93476 30 2.80107 29.789 1.38289 28.5447C0.478075 27.7509 0 26.661 0 25.3947V14.2501C0 10.2875 2.69198 0 15 0C27.3048 0 30 10.2875 30 14.2501"
        fill={props.color || colors.white}
      />
    </svg>
  )
}

export default StoriesIcon
